var dispatcher = require("../dispatcher");

module.exports = {
    saveChangePassword: function (ChangePassword) {
        dispatcher.dispatch({
            ChangePassword: ChangePassword,
            type: "ChangePassword:saveChangePassword"
        })
    },
    
    OTPPasswordReset: function (Password) {
        dispatcher.dispatch({
            Password: Password,
            type: "ChangePassword:OTPPasswordReset"
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/ChangeUserPasswordAction.js